// extracted by mini-css-extract-plugin
export var subtitle = "_dg-2";
export var title = "_dg-0";
export var titleNoWrap = "_dg-1";